import { reelHeaderInitializing } from "@/helpers/reelHeaderInitializing.js";
import { groupNameUpdateAction } from "@/modules/actions/groupNameUpdateAction.js";
import { getSwiperInstance } from "@/helpers/swiperInstance";
import { isCampaignLoopPlaybackEnabled } from "@/helpers/campaignSettings";
import { isReelLike } from '@/helpers/isReelLike';

export const  navigateMediaItem = () => {
  const storeeelItems = window.storeeelItems;
  const groups = storeeelItems?.contentGroups || [];

  // SP＋circle は loop（複製スライド）や非同期の都合で window.iconId がズレることがあるため、
  // 可能なら「表示中のスライドDOM」からグループIDを確定する。
  const resolveCurrentGroupId = () => {
    const isMobile = Boolean(storeeelItems?.isMobile);
    const frame = storeeelItems?.frame;
    const isMobileCircle = isMobile && frame === 'circle';
    // リール型・タイル型はアクティブスライドDOMからグループIDを解決する
    const isMobileSquare = isMobile && isReelLike(frame);

    if ((isMobileCircle || isMobileSquare) && typeof document !== 'undefined') {
      const wrapper = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper');
      const groupId = wrapper?.getAttribute?.('group-id');
      if (groupId != null && String(groupId).length > 0) return String(groupId);
    }

    const raw = window.iconId;
    if (raw == null) return '';
    const rawStr = String(raw);
    // 頻度挿入グループIDはハイフンを含む複合文字列のため split('-').pop() では正しく取れない。
    // rawStr が contentGroups に直接一致する場合は分割せずそのまま返す。
    if (groups.some(g => String(g.id) === rawStr)) return rawStr;
    return rawStr.split('-').pop();
  };

  window.iconId = resolveCurrentGroupId();
  const currentGroupIndex = groups.findIndex(group => String(group.id) === String(window.iconId));
  let currentGroup = groups[currentGroupIndex];

  const swiper = getSwiperInstance();
  const swiperCanLoop = Boolean(swiper?.params?.loop);
  const loopPlaybackEnabled = isCampaignLoopPlaybackEnabled(window.storeeelItems);
  const isCircle = window.storeeelItems?.frame === 'circle';
  // リール型・タイル型(SP)はSwiperのloopでループ移動する
  const isMobileSquare = Boolean(window.storeeelItems?.isMobile) && isReelLike(window.storeeelItems?.frame);
  // ループ可否
  // - ストーリー型（circle）: loop_playback_enabled=true のときだけ（単一グループでもループ）
  // - リール型（SP＋square）: Swiper の loop（複製スライド）を使って末尾→先頭へループ
  const shouldLoopPlayback =
    (
      isCircle
      && loopPlaybackEnabled
      && groups.length > 0
    )
    || (
      swiperCanLoop
      && isMobileSquare
      && groups.length > 0
    );
  const shouldLoopGroupNav =
    (
      isCircle
      && loopPlaybackEnabled
      && groups.length > 1
    )
    || (
      swiperCanLoop
      && isMobileSquare
      && groups.length > 0
    );

  if (!currentGroup) {
    return false;
  }

  if (shouldLoopGroupNav && currentGroupIndex !== -1) {
    window.prevGroup = groups[(currentGroupIndex - 1 + groups.length) % groups.length];
    window.nextGroup = groups[(currentGroupIndex + 1) % groups.length];
  } else {
    window.prevGroup = groups[currentGroupIndex - 1];
    window.nextGroup = groups[currentGroupIndex + 1];
  }

  if (currentGroup.contents[window.moviePosition] == undefined) {
    // 同じグループ内に前後のコンテンツがない場合
    if (window.moviePosition == -1 ) {
      // 前のコンテンツがない場合は前のグループの最後のコンテンツを取得
      currentGroup = groups[currentGroupIndex - 1]
      if (currentGroup == undefined) {
        if (!shouldLoopPlayback) {
          // 前のグループがない場合は処理を終了
          return false;
        }
        currentGroup = groups[groups.length - 1];
      }
      // Swiper のスライド移動先（loop/clone環境向け）
      window._storeeelPendingGroupSlideIndex = groups.findIndex(g => g === currentGroup);
      window.iconId = currentGroup.id;
      window.moviePosition = currentGroup.contents.length - 1;
      groupNameUpdateAction(currentGroup.name);
      if (!window.storeeelItems.isMobile) {
        reelHeaderInitializing(currentGroup.contents.length);
      }
      return currentGroup.contents
    } else {
      // 次のコンテンツがない場合は次のグループの最初のコンテンツを取得
      currentGroup = groups[currentGroupIndex + 1]
      if (currentGroup == undefined) {
        if (!shouldLoopPlayback) {
          // 次のグループがない場合は処理を終了
          return false;
        }
        currentGroup = groups[0];
      }
      // Swiper のスライド移動先（loop/clone環境向け）
      window._storeeelPendingGroupSlideIndex = groups.findIndex(g => g === currentGroup);
      window.iconId = currentGroup.id;
      window.moviePosition = 0;
      groupNameUpdateAction(currentGroup.name);
      if (!window.storeeelItems.isMobile) {
        reelHeaderInitializing(currentGroup.contents.length);
      }
      return currentGroup.contents
    }
  } else {
    // 同じグループ内の前後のコンテンツを取得
    // groupNameUpdateAction(currentGroup.name);
    return currentGroup.contents
  }
}
